import React from 'react';
import UserPanel from './UserPanel';
import Explore from './Explore';
import Starred from './Starred';
import Channels from './Channels';
import DirectMessages from './DirectMessages';
import { Menu } from 'semantic-ui-react';
import '../App.css';
import scyreLogo from '../Images/scyre-color.png'

class SidePanel extends React.Component {

    render() {

        return (
            <div>
            <input type="checkbox" id="chk" />
            <label for="chk" class="show-menu-btn">
            <div className="burger">
          <div className="line1" />
          <div className="line2" />
          <div className="line3" />
            </div>
            </label>
            <Menu
                inverted
                fixed="left"
                vertical
                className="disable-scrollbars menuSidePanel"
            >
                <div style={{ background: '#F8F8F8',
                    height: '45px',
                    width: '112.5%', 
                    marginLeft: '-20px'
                }}
                className="inAppLogoDiv"
                >
                    <img
                     className="scyreAppLogo"
                     src={scyreLogo}
                     alt="Scyre Logo"
                    />
        </div> 
                <label for="chk" class="hide-menu-btn">
                    <div className="xButton">
                        <div className="x-one" />
                        <div className="x-two" />
                    </div>
                </label>
                <UserPanel />
                <Explore />
                <Starred />
                <Channels />
                <DirectMessages />
            </Menu>
            </div>
        );
    }
}

export default SidePanel;


// WEBPACK FOOTER //
// ./src/components/SidePanel/SidePanel.js